<div class="widget theme-light">
  <router-outlet></router-outlet>

  <div class="widget__messages pt-2 pr-2 pl-2">

    <!-- http warning -->
    <app-https-validation *ngIf="embedded$ | async" [url]="parentURL$ | async">
    </app-https-validation>

    <!-- ie11 warning -->
    <app-ie-warning appShowIE11></app-ie-warning>

  </div>
</div>

<div class="widget-shell"></div>